// services/MeasurementToolManager.js
import { EventsEnum } from "../classes/enums/EventsEnum";
import { InteractiveTools } from "../classes/enums/ToolsEnum";

class MeasurementToolManager {
  constructor() {
    this.selectedTool = null;
    this.isWaitingForView = false;
    this.callbacks = new Set();
  }

  // Select a measurement tool and enter waiting mode
  selectTool(toolName) {
    this.selectedTool = toolName;
    this.isWaitingForView = true;

    if (
      [
        InteractiveTools.ANGLE_KYPHOSIS,
        InteractiveTools.ANGLE_LORDOSIS,
      ].includes(toolName)
    ) {
      // Dispatch event to update UI state
      window.dispatchEvent(
        new CustomEvent(EventsEnum.SHOW_SAGITTAL_ADVANCED_MEASUREMENT, {
          detail: { tool: toolName, isWaiting: true },
        })
      );
    } else if ([InteractiveTools.ANGLE_COBB].includes(toolName)) {
      // Dispatch event to update UI state
      window.dispatchEvent(
        new CustomEvent(EventsEnum.SHOW_CORONAL_ADVANCED_MEASUREMENT, {
          detail: { tool: toolName, isWaiting: true },
        })
      );
    }

    // Auto-clear after 30 seconds if no view is selected
    setTimeout(() => {
      if (this.isWaitingForView && this.selectedTool === toolName) {
        this.clearSelection();
      }
    }, 30000);
  }

  // Execute tool on selected view - now accepts callback that can handle mouse position
  executeOnView(viewData, addMeasurementCallback) {
    if (!this.isWaitingForView || !this.selectedTool) {
      return false;
    }

    // Return a function that will be called with the mouse position
    return mousePosition => {
      // Execute the measurement addition with mouse position
      addMeasurementCallback(
        this.selectedTool,
        viewData.viewName,
        mousePosition
      );

      // Clear selection
      this.clearSelection();

      return true;
    };
  }

  // Clear current tool selection
  clearSelection() {
    const wasWaiting = this.isWaitingForView;
    this.selectedTool = null;
    this.isWaitingForView = false;

    if (wasWaiting) {
      window.dispatchEvent(
        new CustomEvent(EventsEnum.MEASUREMENT_TOOL_CLEARED)
      );
    }
  }

  // Get current state
  getState() {
    return {
      selectedTool: this.selectedTool,
      isWaitingForView: this.isWaitingForView,
    };
  }

  // Check if currently waiting for view selection
  isWaiting() {
    return this.isWaitingForView;
  }

  // Check if specific tool is selected
  isToolSelected(toolName) {
    return this.selectedTool === toolName;
  }
}

// Create singleton instance
const measurementToolManager = new MeasurementToolManager();

export default measurementToolManager;
